module.exports = __webpack_public_path__ + "b13259a883b55a7e7ab3c58fd8336cf4.png";